export const DESCRIPTIVE_ROW_DIALOG_TEMPLATE = 'Web.TemplatesInterface.v1_0.Touch.DescriptiveRowDialogTemplateInterface.DescriptiveRowDialogTemplate';
